import { useEffect } from "react";
import { storeUTMParams } from "../../utils/hubspotUtils";
import { HUBSPOT_PORTAL_ID } from "../../utils/constants/appConstants";

const HubspotLoader = () => {
  storeUTMParams();
  useEffect(() => {
    if (!HUBSPOT_PORTAL_ID) {
      return;
    }
    if (!document.getElementById("hs-script-loader")) {
      const script = document.createElement("script");
      script.src = `//js-ap1.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`;
      script.async = true;
      script.defer = true;
      script.id = "hs-script-loader";
      document.body.appendChild(script);
    }
  }, []);

  return null;
};

export default HubspotLoader;
